import { render, staticRenderFns } from "./OfferGroups.vue?vue&type=template&id=c973f5b6&"
import script from "./OfferGroups.vue?vue&type=script&lang=js&"
export * from "./OfferGroups.vue?vue&type=script&lang=js&"
import style0 from "./OfferGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VListItem,VProgressCircular})
